/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import { gql } from '@apollo/client';
import { WORKER_DATA_FRAGMENT } from '../fragments/worker';

export const UPDATE_PLAYGROUND_DOCUMENT = gql`
  mutation updateWorkerDocument(
    $workerId: ID!
    $document: [SentenceInput!]!
    $shouldStartExecution: Boolean!
    $useAutopilot: Boolean
    $documentToken: String # $isLocalOnly: Boolean
    $startFromUiLineId: String
  ) {
    updateWorkerDocument(
      input: {
        workerId: $workerId
        document: $document
        shouldStartExecution: $shouldStartExecution
        useAutopilot: $useAutopilot
        documentToken: $documentToken
        # isLocalOnly: $isLocalOnly
        startFromUiLineId: $startFromUiLineId
      }
    ) {
      sentences {
        lineId
        text
        shouldPause
        parentId
        language
        metadata {
          lineId
          parentId
        }
        internalMetadata {
          key
          value
        }
      }
      updatedAt
    }
  }
`;

export const CREATE_MINI_PLAYGROUND = gql`
  mutation CreateMiniPlayground($input: CreateMiniPlaygroundInput!) {
    createMiniPlayground(input: $input) {
      id
      workerId
      createdAt
      forwardedAt
      invokedAt
      receivedAt
      processingAt
      skippedAt
      processedAt
      failedAt
      workErrors
      createdBy
      lineId
      lineToken
    }
  }
`;

export const DUPLICATE_WORKERS = gql`
  ${WORKER_DATA_FRAGMENT}
  mutation DuplicateWorkers(
    $departmentId: ID!
    $workerIds: [ID!]!
    $owner: String
    $runWorker: Boolean = true
  ) {
    duplicateWorkers(
      departmentId: $departmentId
      workerIds: $workerIds
      owner: $owner
      runWorker: $runWorker
    ) {
      ...workerData
    }
  }
`;

export const REPLAY_WORKERS_RUN = gql`
  ${WORKER_DATA_FRAGMENT}
  mutation ReplayWorkers(
    $departmentId: ID!
    $workerIds: [ID!]!
    $owner: String = null
    $runWorker: Boolean = true
    $brainVersion: String = null
    $isReplay: Boolean = false
  ) {
    duplicateWorkers(
      departmentId: $departmentId
      workerIds: $workerIds
      owner: $owner
      runWorker: $runWorker
      brainVersion: $brainVersion
      isReplay: $isReplay
    ) {
      ...workerData
    }
  }
`;

export const UPDATE_WORKER = gql`
  mutation updateWorker($id: ID!, $name: String) {
    updateWorker(input: { id: $id, name: $name }) {
      id
      name
    }
  }
`;

export const ARCHIVE_WORKER = gql`
  mutation toggleWorkerArchiveStatus($input: ToggleWorkerArchiveStatusInput!) {
    toggleWorkerArchiveStatus(input: $input) {
      id
      name
    }
  }
`;

export const CREATE_WORKER = gql`
  mutation CreateWorker($input: CreateWorkerInput!, $local: Boolean) {
    createWorker(input: $input, local: $local) {
      id
      owner
      readers
      editors
      name
      description
      version
      departmentVersion
      knowledgeId
      departmentId
      procedureId
      entryCommand
      entryCommandId
      originalWorkerId
      createdAt
      state
      stateLastUpdatedAt
      attachments
      isArchived
      features
      replayWorkerId
    }
  }
`;
